import { I18n } from '@/services/i18n';

type Message = {
  declined: string;
};

const messages: I18n<Message> = {
  en: {
    declined: 'Chat Request declined',
  },
  es: {
    declined: 'Solicitud de chat rechazada',
  },
  de: {
    declined: 'Chat-Anfrage abgelehnt',
  },
};

export { messages };
